export const PAYFAST_PAY_REQUEST = "PAYFAST_PAY_REQUEST";
export const PAYFAST_PAY_SUCCESS = "PAYFAST_PAY_SUCCESS";
export const PAYFAST_PAY_FAIL = "PAYFAST_PAY_FAIL";
export const PAYFAST_PAY_RESET = "PAYFAST_PAY_RESET";

export const PAYFAST_ACTION_REQUEST = "PAYFAST_ACTION_REQUEST";
export const PAYFAST_ACTION_SUCCESS = "PAYFAST_ACTION_SUCCESS";
export const PAYFAST_ACTION_FAIL = "PAYFAST_ACTION_FAIL";
export const PAYFAST_ACTION_RESET = "PAYFAST_ACTION_RESET";

export const PAYFAST_SIGNATURE_REQUEST = "PAYFAST_SIGNATURE_REQUEST";
export const PAYFAST_SIGNATURE_SUCCESS = "PAYFAST_SIGNATURE_SUCCESS";
export const PAYFAST_SIGNATURE_FAIL = "PAYFAST_SIGNATURE_FAIL";
